export default __webpack_public_path__ + "static/banner_speech-730192088d27bdf48ea0418d512fbf84.webp";